import { getI18nLocale } from "../../modules/i18n/i18n";
import { getAppLocaleConfig } from "../../modules/i18n/localeRegistry";

export const getBrowserTimezone = () => {
    const locale = getAppLocaleConfig(getI18nLocale()).intlLocale;
    const timeZonePart = new Intl.DateTimeFormat(locale, { timeZoneName: "long" }).formatToParts(new Date()).find((part) => part.type === "timeZoneName");
    return timeZonePart?.value ?? Intl.DateTimeFormat().resolvedOptions().timeZone;
};

export const getMinutesFromTime = (date: Date) => {
    const hours = date.getHours();
    const minutes = date.getMinutes();
    return hours * 60 + minutes;
};

export const createDateObjectFromMinutes = (minutes: number) => {
    const hours = minutes / 60 === 24 ? 0 : Math.floor(minutes / 60);
    const mins = minutes % 60;
    return new Date(0, 0, 0, hours, mins);
};
